export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgRGF0ZVJhbmdlID0gewogIGRhdGVSYW5nZTogewogICAgc3RhcnREYXRlOiBzdHJpbmcKICAgIGVuZERhdGU6IHN0cmluZwogIH0KfQo="